/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Keys_F7Inputs */

const en_wc_tut_keys_f7 = /** @type {(inputs: Wc_Tut_Keys_F7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelling and grammar`)
};

/**
* | output |
* | --- |
* | "Spelling and grammar" |
*
* @param {Wc_Tut_Keys_F7Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_keys_f7 = /** @type {((inputs?: Wc_Tut_Keys_F7Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Keys_F7Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_keys_f7(inputs)
});
export { wc_tut_keys_f7 as "wc.tut.keys.f7" }